import { DenominatorLabels } from '@constants/page';
import { PageGranularity } from 'types/Page.types';

/** Available reporting periods for page setup. Will be replaced by API-driven supportedPageGrains in the future. */
export const REPORTING_PERIODS = [PageGranularity.MTD, PageGranularity.QTD, PageGranularity.YTD] as const;

/**
 * Selectable options for the '% Denominator selector' in Page Details step
 */
export const DenominatorSelectLabels = {
  NO_DENOMINATOR_REQUIRED: 'No Denominator Required',
  ...DenominatorLabels,
} as const;
